export default "/images/0aa37557a04ce854070cb309bef4d831.avif";